import dayjs from "dayjs";

export default function QrCodeRondaLocaisSelecionado({ registros, filtros }:iProps) {
    if (registros.length === 0) { 
        return (
            <div className="div-row">
                <span className="material-symbols-outlined" style={{ fontSize: "3.8em", marginRight: "5px" }}>
                    apartment
                </span>
                <p>Nenhum local selecionado</p>
            </div>
        );
    }
    
    let empresas: string = ""
    let centros: string = ""
    let colaboradores: string = ""
    
    let empresasSelecionadas:any[] = filtros.id_empresa
    let centrosSelecionadas:any[] = filtros.id_centro_custo
    let colaboradoresSelecionadas: any[] = filtros.id_colaborador
    
    if (empresasSelecionadas.length > 0) { 
        let empresasAux = ""
        empresasSelecionadas.map((value, idx, arr) => { 
            if (empresasAux === "") {
                empresasAux = `${value.label}`
            } else { 
                empresasAux = `${empresasAux}, ${value.label}`
            }
            return empresasAux
        })
        empresas = empresasAux
    }
    if (centrosSelecionadas.length > 0) { 
        let centrosAux = ""
        centrosSelecionadas.map((value, idx, arr) => { 
            if (centrosAux === "") {
                centrosAux = `${value.label}`
            } else { 
                centrosAux = `${centrosAux}, ${value.label}`
            }
            return centrosAux
        })
        centros = centrosAux
    }
    if (colaboradoresSelecionadas.length > 0) { 
        let colaboradoresAux = ""
        colaboradoresSelecionadas.map((value, idx, arr) => { 
            if (colaboradoresAux === "") {
                colaboradoresAux = `${value.label}`
            } else { 
                colaboradoresAux = `${colaboradoresAux}, ${value.label}`
            }
            return colaboradoresAux
        })
        colaboradores = colaboradoresAux
    }
    
    const DATA_INICIAL = dayjs(filtros.data_inicial).format("DD/MM/YYYY")
    const DATA_FINAL = dayjs(filtros.data_final).format("DD/MM/YYYY")
    
    return (
        <div className="div-row">
            <span className="material-symbols-outlined" style={{ fontSize: "3.8em", marginRight: "5px" }}>
                apartment
            </span>
            <div>
                {/*<p>Filtro selecionado:</p>*/}
                <p>Período {DATA_INICIAL} até {DATA_FINAL}, {registros.length} registros</p>
                <p>{empresas}</p>
                <p>{centros}</p>
                <p>{colaboradores}</p>
            </div>
        </div>
    );
}

interface iProps { 
    registros: any[]
    filtros: any
}
